module.exports = __webpack_public_path__ + "img/ai-gen.7c55b40e.png";